import React from "react";
import { Link } from "react-router-dom";
import Monogram from "@/components/Monogram";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/real-estate-activities", label: "Real Estate Activities" },
  { to: "/partners-approach", label: "Partners & Approach" },
  { to: "/contact", label: "Contact" },
];

const LEGAL = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Use" },
  { to: "/cookies", label: "Cookie Notice" },
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-soft"
    >
      <div className="container-tight py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-3" data-testid="footer-brand">
              <Monogram className="h-10 w-10" />
              <div>
                <div className="font-display text-lg font-bold text-navy">
                  Taonga OÜ
                </div>
                <div className="text-xs uppercase tracking-[0.22em] text-charcoal/60">
                  Estonia
                </div>
              </div>
            </Link>
            <p className="mt-5 text-[15px] leading-relaxed text-charcoal max-w-md">
              Estonian company active in real estate activities and property-related operations.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-5">Navigate</div>
            <ul className="space-y-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-[14px] text-charcoal hover:text-navy transition-colors nav-link"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="overline mb-5">Legal</div>
            <ul className="space-y-3">
              {LEGAL.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-legal-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-[14px] text-charcoal hover:text-navy transition-colors nav-link"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-5">Registered</div>
            <ul className="space-y-2 text-[14px] text-charcoal">
              <li>Taonga OÜ</li>
              <li>Established 2016 · Estonia (EE)</li>
              <li className="text-charcoal/70">Registry code: 14152771</li>
              <li>
                <a
                  href="mailto:info@taonga.eu"
                  className="text-charcoal hover:text-navy transition-colors"
                  data-testid="footer-email"
                >
                  info@taonga.eu
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="mt-12 pt-8 border-t border-border text-[12px] leading-relaxed text-charcoal/70"
          data-testid="footer-compliance"
        >
          <p className="max-w-3xl">
            Taonga OÜ operates exclusively with its own capital and does not
            provide regulated financial services or third-party asset management.
          </p>
          <p className="mt-3 text-charcoal/60">
            © {year} Taonga OÜ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
